import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/apiClient";
import Dashboard from "../pages/Dashboard";
import DoctorDashboard from "../pages/DoctorDashboard";
import { Loader2 } from "lucide-react";

export default function DashboardRouter() {
  const { data: user, isLoading } = useQuery({
    queryKey: ["user"],
    queryFn: () => apiClient.get("/api/auth/me"),
  });

  if (isLoading) {
    return (
      <div className="p-6 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  // Determine which dashboard to show based on user type
  const userType = user?.userType;
  
  if (userType === 'doctor' || userType === 'practiceOwner') {
    return <DoctorDashboard />;
  } else {
    // Default to patient dashboard for patients or unknown user types
    return <Dashboard />;
  }
}